var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ee-banner",
    style: (_vm.style)
  }, [_c('transition-group', {
    staticClass: "ee-banner__img-list",
    style: (_vm.style),
    attrs: {
      "tag": "div",
      "name": "slide"
    }
  }, _vm._l((_vm.banners), function(banner, index) {
    return _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.show(index)),
        expression: "show(index)"
      }],
      key: banner,
      staticClass: "ee-banner__img",
      style: (_vm.imgStyle(banner.imgUrl)),
      attrs: {
        "href": banner.href,
        "target": "_blank"
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "ee-banner__nav-bar"
  }, _vm._l((_vm.banners), function(banner, index) {
    return _c('span', {
      class: {
        'is-active': index === _vm.cur
      },
      on: {
        "click": function($event) {
          _vm.handlePause(index)
        },
        "mouseout": _vm.handleStart
      }
    })
  }))], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13c81776","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/packages/banner/Banner.vue
// module id = 555
// module chunks = 13